export const SUGGESTIONS = {id: 'common.suggestions', defaultMessage: 'SUGGESTIONS'};

export function processAutoSuggestResponse(resp = []) {
  const processesResp = {};
  let data = [];
  if (Array.isArray(resp)) {
    resp.map(res => {
      if (res.gid && processesResp[res.gid]?.[0]?.group) {
        processesResp[res.gid][0].group.push(res);
        processesResp[res.gid][0]['hasChilds'] = true;
      } else if (res.id) {
        processesResp[res.id] = [];
        res.group = [];
        processesResp[res.id].push(res);
      } else if (res.place_id) {
        processesResp[res.place_id] = [];
        res.group = [];
        processesResp[res.place_id].push(res);
      }
    });
  }

  const otherSuggestions = {
    title: {...SUGGESTIONS},
    citieslist: [],
  };
  Object.keys(processesResp).forEach(key => {
    otherSuggestions.citieslist.push(processesResp[key][0]);
    if (processesResp[key][0].group.length > 0) {
      processesResp[key][0].isParent = true;
      processesResp[key][0].group.map((grp, idx) => {
        if (idx === processesResp[key][0].group.length - 1) {
          grp.lastElem = true;
        }
        grp.isChild = true;
        otherSuggestions.citieslist.push(grp);
      });
    }
  });
  data = otherSuggestions.citieslist.filter(item => !item?.isChild);
  return data;
}

// Function to Map Selected Item From New AutoSuggest Dropdown to Existing Redux Store Structure
export function updateAutoSuggestSelection(selectedItem) {
  let requiredDestinationObject = {
    name: '',
    n: '', // Name
    t: '', // Type
    _id: '', // Id
    crd: [], // Coordinates
    ct: {}, // City Info
    xtr: {}, // Extra info
    s_sc: 0, // TBD
    display_property_type: '', // Property type display value
    contextId: {},
    locus: {},
    mmtId: null,
  };
  let {
    name = '',
    displayName = '',
    htype = '',
    type = '',
    voyId = '', //8717279093827200968  >> GOA city id, for testing use this if this field is not coming in response
    centre = {},
    context = {},
    countryCode = '',
    isClickable,
    locType = '',
    place_id,
    contextId = {},
    id = '',
    cityVoyId = '',
    cityName = '',
    cityCode = '',
    dummyId = '',
    subLocations,
  } = selectedItem;

  let voyType = type;
  if (type?.toLowerCase() === 'poi') {
    voyType = 'landmark';
  }
  if (id) {
    requiredDestinationObject.mmtId = id; // For MMT hotel ID if available in response
  }
  displayName = displayName.split(',')[0] || '';
  requiredDestinationObject.name = name;
  requiredDestinationObject.n = displayName;
  requiredDestinationObject.t = !place_id ? voyType?.toLowerCase() : htype.toLowerCase();
  requiredDestinationObject.display_property_type = htype;
  requiredDestinationObject._id = voyId || dummyId;
  // requiredDestinationObject.contextId = contextId;
  // requiredDestinationObject.contextId = getLocusCode(id, contextId, type?.toLowerCase() || '');
  requiredDestinationObject.contextId = context?.id;
  if (centre?.lat && centre?.lng) {
    requiredDestinationObject.crd = [centre?.lat, centre?.lng];
  }
  requiredDestinationObject.ct = {
    n: cityName || context?.name || '',
    _id: cityVoyId || voyId || context?.voyId || dummyId,
  };
  requiredDestinationObject.xtr = {
    cc: countryCode,
    type: voyType,
    lca: isClickable,
  };
  if (voyType == 'landmark' || voyType == 'area') {
    requiredDestinationObject.xtr['flt'] = {
      loc: {},
    };
    requiredDestinationObject.xtr.flt.loc = {
      n: displayName || '',
      _id: context?.voyId || dummyId,
      mmId: id,
      mmType: type,
    };
  }
  if (place_id) {
    requiredDestinationObject.xtr['ggl_id'] = place_id;
    requiredDestinationObject['place_id'] = place_id;
  }
  const isCityType = type?.toLowerCase() === 'city';
  requiredDestinationObject.locus = {
    id: (isCityType ? cityCode : context?.id) || cityCode,
    type: (isCityType ? type : context?.type) || type,
    cityCode: cityCode,
  };
  if (subLocations?.length) {
    requiredDestinationObject['subLocations'] = subLocations;
  }

  return requiredDestinationObject;
}

export function modifyNewAutoSuggestResponse(resp) {
  const newSuggestions = processAutoSuggestResponse(resp);
  return newSuggestions;
}

export function getLocusCode(id = '', contexId = {}, type = '') {
  let locusCode = id;
  if (
    contexId !== null &&
    type &&
    (type == 'poi' || type == 'gpoi' || type == 'google' || type == 'area' || type == 'hotel')
  ) {
    if (contexId.hasOwnProperty(type)) {
      locusCode = contexId[type];
    }
  }
  return locusCode;
}
